




<div *ngIf="phoneApp">
  <div class="daPic">
    <div style="text-align: center">
      <div class="titleFont" style="padding-top: 40%; color:white;font-size: 30px; padding-left: 0">Import Status Inquiry </div>

    </div>

    <table style="width: 100%; height: 100%; padding-top: 1%; margin: 0px">
      <tr>
        <td  >
          <table  class="table-fill" style="height: 100%; text-align: center">
            <tr>
              <td style="vertical-align: top;">
                <div>
                  <mat-card class="speech-bubble3" style="text-align: center;background-color: rgba(238,238,237,1); " xmlns="http://www.w3.org/1999/html">
                    <div class="lowerCaseLetters" style="font-size: 14px;text-align: left; padding-left: 5%;padding-bottom: 3px ">Container Number</div>
                    <mat-form-field class="newField" style=" font-size: 17px; min-width: 90%; max-width: 90%; padding: 10px" appearance="outline" >
                      <input  [(ngModel)]="txtFromArea"  matInput cdkTextareaAutosize oninput="this.value = this.value.toUpperCase()">
                      <mat-icon (click)="getSearchItems()" matSuffix><img style="vertical-align: center;" src="assets/search.svg" ></mat-icon>

                    </mat-form-field>
                    <div style="padding-bottom: 15px; padding-top: 5px; text-align: center">
                      <div class="errorDiv2" *ngIf=" didntEnterShit">Must Have 1 Container</div>
                      <div class="errorDiv2" *ngIf="badContainer">No Container Found or Unauthorized to view</div>
                      <div class="errorDiv2" *ngIf="navisError!=null">{{navisError}}</div>
                      <div class="errorDiv2" *ngIf="insertNoConts">Must Have At Least 1 Container For Insert</div>
                    </div>

                  </mat-card>
                </div>



                <div *ngIf="showDetailScreen">

                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">

                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="status"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Status</div>
                      </div>

                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Release Status</mat-label>
                        <input *ngIf="isv.available=='Yes'" value="Available" style="color: green" matInput readonly/>
                        <input *ngIf="isv.available=='No'" value="Not Released" style="color: #E61E00" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>

                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="container"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Container Information</div>
                      </div>

                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Line ID</mat-label>
                        <input [(ngModel)]="isv.line_description" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">ISO</mat-label>
                        <input [(ngModel)]="isv.iso_description" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Freight</mat-label>
                        <input [(ngModel)]="isv.freight_kind_description" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Group</mat-label>
                        <input [(ngModel)]="isv.group_code" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Hazardous</mat-label>
                        <input [(ngModel)]="isv.hazardousFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Reefer</mat-label>
                        <input [(ngModel)]="isv.requires_powerFmt" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>



                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="vessel"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Vessel Information</div>
                      </div>

                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Vessel</mat-label>
                        <input [(ngModel)]="isv.vessel_description" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Voyage</mat-label>
                        <input [(ngModel)]="isv.voyage" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Port of Discharge</mat-label>
                        <input [(ngModel)]="isv.pod_unloccode_description" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Port of Loading</mat-label>
                        <input [(ngModel)]="isv.pol_unloccode_description" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>


                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="weights"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Weight Information</div>
                      </div>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Gross Weight</mat-label>
                        <input [(ngModel)]="isv.gross_weightFmt" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>

                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="holds"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Holds & Releases</div>
                      </div>

                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Customs Hold</mat-label>
                        <input [(ngModel)]="isv.customs_releasedFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Freight Released</mat-label>
                        <input [(ngModel)]="isv.freight_released_fmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">USDA Hold</mat-label>
                        <input [(ngModel)]="isv.usda_releasedFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Other Agency Hold</mat-label>
                        <input [(ngModel)]="isv.other_agency_releasedFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Terminal Hold</mat-label>
                        <input [(ngModel)]="isv.holdsFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Location</mat-label>
                        <input [(ngModel)]="isv.last_pos_name" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>

                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">

                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="payment"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Demurrage & Charges</div>
                      </div>

                      <div class="lowerCaseLetters" style=" font-size: 14px;text-align: left; padding-left: 5%;padding-bottom: 10px ">Demurrage & Charges </div>

                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Discharge Date</mat-label>
                        <input [(ngModel)]="isv.received_date_fmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">FreeTime Start</mat-label>
                        <input [(ngModel)]="isv.fte_start_date" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">FreeTime End</mat-label>
                        <input [(ngModel)]="isv.fte_date_fmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Free Days</mat-label>
                        <input [(ngModel)]="isv.free_days" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field  *ngIf="!isPortAuthority()"  class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Maher Demurrage Balance Due</mat-label>
                        <input [(ngModel)]="isv.demurrageBalanceDueMaherFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field  *ngIf="!isPortAuthority()"  class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Line Op Demurrage Balance Due</mat-label>
                        <input [(ngModel)]="isv.demurrageBalanceDueLineFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field  *ngIf="!isPortAuthority()"  class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Total Demurrage Balance Due</mat-label>
                        <input [(ngModel)]="isv.demurrageBalanceDueFmt" matInput readonly/>
                      </mat-form-field>


                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Demurrage Days</mat-label>
                        <input [(ngModel)]="isv.demurrageDays" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field *ngIf="!isPortAuthority()" class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Power Balance Due</mat-label>
                        <input [(ngModel)]="isv.powerBalanceDueFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field *ngIf="!isPortAuthority()" class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Exam Charges Due</mat-label>
                        <input [(ngModel)]="isv.examChargesDueFmt" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>



                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">

                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="visit"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Out Truck Activity</div>
                      </div>

                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Delivered Date</mat-label>
                        <input [(ngModel)]="isv.delivered_date_fmt" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>

                  <div style="padding-top: 8%" *ngIf="this.hArray!=null && this.hArray.length>0">
                    <mat-card class="iso-bubble"  style="text-align: center;background-color:rgba(238,238,237,0.7); " xmlns="http://www.w3.org/1999/html">

                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="cholds"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Container Holds</div>
                      </div>

                      <div class="flex-item2" >
                        <mat-table #table4 [dataSource]="holdsData2" multiTemplateDataRows matSort="container" >
                          <ng-container matColumnDef="type" >
                            <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Type</mat-header-cell>
                            <mat-cell *matCellDef="let row">{{row.type}}</mat-cell>
                          </ng-container>
                          <ng-container matColumnDef="code" >
                            <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">ID</mat-header-cell>
                            <mat-cell *matCellDef="let row">{{row.code}}</mat-cell>
                          </ng-container>
                          <ng-container matColumnDef="description" >
                            <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Description</mat-header-cell>
                            <mat-cell *matCellDef="let row">{{row.description}}</mat-cell>
                          </ng-container>
                          <mat-header-row *matHeaderRowDef="holdsColumns; sticky: true"></mat-header-row>
                          <mat-row   *matRowDef="let row; columns: holdsColumns;" class="table-row"></mat-row>
                        </mat-table>
                      </div>
                    </mat-card>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </div>


</div>



<table class="mainTable" style="width: 100%">
  <tr>
    <td class="mainUpperTd">


      <mat-card class="quickView" *ngIf="showQuickView">
        <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
          <tr>
            <td style="width: 0%" >
              <div class="maher" (click)="myApp.showCharts()"></div>
            </td>
            <td style="width: 70%">
              <div >
                <mat-form-field class="search"  appearance="outline">
                  <mat-label style="padding-left: 20px;">Search by Container, Line Id, Dates, Vessel, Customs Status, Freight Status</mat-label>
                  <mat-icon matPrefix ><img style="vertical-align: center;height:25px; width: 25px" src="assets/cargo_container.png" ></mat-icon>
                  <input  maxlength="30" style="padding-left: 20px;"  matInput (keyup)="applyFilter($event.target.value)"  [formControl]="search1">
                </mat-form-field>
              </div>
              <div class="lowerCaseLetters" style="font-size: 14px; padding-left: 24%">Click On Any Row To View Details For The Container</div>
            </td>
            <td style="width: 20%" *ngIf="ipadApp">
              <div >
                <div class="lowerCaseLetters" *ngIf="this.ipadApp" (click)="returnToSearch()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Search</div>
              </div>
            </td>
          </tr>
        </table>

        <div class="flex-item2" >
          <mat-table #table23 [dataSource]="quickViewData" multiTemplateDataRows matSort="container" >
            <ng-container matColumnDef="container" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Container</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.container}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="available" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Available</mat-header-cell>
              <mat-cell [className]="row.available == 'Yes'? 'greenColor' : 'redColor'" *matCellDef="let row">{{row.available}}</mat-cell>

            </ng-container>
            <ng-container matColumnDef="line_id" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Line Op</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.line_id}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="iso_description" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">ISO</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.iso_description}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="freight_kind_description" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Freight</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.freight_kind_description}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="received_date_fmt" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Discharged</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.received_date_fmt}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="vesselVoyage" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Vessel/Voyage</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.vesselVoyage}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="delivered_date_fmt" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Delivered</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.delivered_date_fmt}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="customs_released_description" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Customs</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.customs_released_description}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="freight_released_fmt" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Freight</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.freight_released_fmt}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="fte_date_fmt" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">{{freeDayCol}}</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.fte_date_fmt}}</mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="qvColumns; sticky: true"></mat-header-row>
            <mat-row   *matRowDef="let row; columns: qvColumns;" class="table-row" (click)="showDetails(row)"></mat-row>
          </mat-table>
          <mat-toolbar style="width: 100%; display: unset">
            <mat-toolbar-row style="width: 100%; ">
              <mat-paginator class="myPaginator"  [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
              <span style="padding-left: 24%">
                  <button mat-raised-button matTooltip="Export To Excel"  (click)="exportExcel()"><img style="height: 38px"  src="assets/excel.png" ></button>
              </span>
            </mat-toolbar-row>
          </mat-toolbar>
        </div>
      </mat-card>


      <mat-card class="details" *ngIf="showDetailScreen">
        <table style="width: 100%; height: 100%; table-layout: auto" attribute rules=none>
          <tr>
            <td style="width: 100%;">


              <mat-card class="contDetails">
                <table style="width: 100%">
                  <tr>
                    <td style="width: 1%">
                      <div class="maher2" (click)="myApp.showCharts()"></div>
                    </td>
                    <td style="width: 33%">
                      <div class="titleFont" style="padding-left: 0%; font-size: 23px">Line Op:<a style="color: green"> {{isv.line_description | titlecase}}</a></div>
                    </td>
                    <td style="width: 25%">
                      <div class="titleFont" style="padding-left: 0%; font-size: 23px">Container:<a style="color: green"> {{isv.container}}</a></div>
                    </td>
                    <td style="width: 20%">
                      <div class="titleFont" style="padding-left: 0%; font-size: 23px">Transit State:<a style="color: green"> {{isv.transit_state_description}}</a></div>
                    </td>
                    <td style="width: 20%" *ngIf="txtArray2.length>1">
                      <div class="lowerCaseLetters"  (click)="returnToQuickView()" style="font-size: 14px; color: #E61E00; cursor: pointer; text-align: end; padding-right: 10px">Back To Quick View</div>
                    </td>
                    <td style="width: 20%" *ngIf="txtArray2.length==1 && ipadApp">
                      <div class="lowerCaseLetters"  (click)="returnToQuery()" style="font-size: 14px; color: #E61E00; cursor: pointer; text-align: end; padding-right: 10px">Back To Search</div>
                    </td>
                  </tr>
                </table>



                <table style="width: 100%; padding: 0px; margin: 0px">
                  <tr>
                    <td style="width: 85%; height: 100%; text-align: center;" >
                      <table  class="table-fill" style="height: 100%">
                        <tr>
                          <div style="background-color: rgba(23,122,241,0.07); border: #E61E00 1px solid; height: 100%">
                            <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 1%;padding-bottom: 15px ">Container Details</div>
                            <table style="width: 100%">
                              <tr>
                                <td style="vertical-align: top; width: 50%">
                                  <div style="padding-top: 5px">
                                    <mat-form-field appearance="outline" style="min-width: 100%" floatLabel="always">
                                      <mat-label style="font-size: 18px; color: #E61E00">Container</mat-label>
                                      <input [(ngModel)]="isv.container" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline" style="min-width: 100%" floatLabel="always">
                                      <mat-label style="font-size: 18px; color: #E61E00">Freight</mat-label>
                                      <input [(ngModel)]="isv.freight_kind_description" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline" style="min-width: 100%" floatLabel="always">
                                      <mat-label style="font-size: 18px; color: #E61E00">Hazardous</mat-label>
                                      <input [(ngModel)]="isv.hazardousFmt" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div *ngIf="this.myUser.role=='LINEOP'">
                                    <mat-form-field appearance="outline" style="min-width: 100%" floatLabel="always">
                                      <mat-label style="font-size: 18px; color: #E61E00">Commodity</mat-label>
                                      <input [(ngModel)]="isv.commodity" matInput readonly/>
                                    </mat-form-field>
                                  </div>



                                </td>
                                <td style="vertical-align: top; height: 100%; width: 50%">
                                  <div style="padding-top: 5px">
                                    <mat-form-field appearance="outline" style="min-width: 100%" floatLabel="always">
                                      <mat-label style="font-size: 18px; color: #E61E00">ISO</mat-label>
                                      <input [(ngModel)]="isv.iso_description" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline" style="min-width: 100%" floatLabel="always">
                                      <mat-label style="font-size: 18px; color: #E61E00">Lease</mat-label>
                                      <input [(ngModel)]="isv.lease_description" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline" style="min-width: 100%" floatLabel="always">
                                      <mat-label style="font-size: 18px; color: #E61E00">Running Reefer</mat-label>
                                      <input [(ngModel)]="isv.requires_powerFmt" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline" style="min-width: 100%" floatLabel="always">
                                      <mat-label style="font-size: 18px; color: #E61E00">Group</mat-label>
                                      <input [(ngModel)]="isv.group_code" matInput readonly/>
                                    </mat-form-field>
                                  </div>


                                </td>
                              </tr>
                            </table>


                          </div>

                          <td style="vertical-align: top; height: 100%;">
                            <div style="background-color: rgba(238,238,237,0.4); border: #E61E00 1px solid; height: 100%">
                              <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Vessel Information</div>
                              <div style="padding-top: 5px">
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Vessel</mat-label>
                                  <input [(ngModel)]="isv.vessel_description" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div >
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Voyage</mat-label>
                                  <input [(ngModel)]="isv.voyage" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Port of Discharge</mat-label>
                                  <input [(ngModel)]="isv.pod_unloccode_description" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Port of Loading</mat-label>
                                  <input [(ngModel)]="isv.pol_unloccode_description" matInput readonly/>
                                </mat-form-field>
                              </div>
                            </div>
                          </td>


                          <td style="vertical-align: top; height: 100%;">
                            <div style="background-color: rgba(23,122,241,0.07); border: #E61E00 1px solid; height: 100%">
                              <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Weight Information</div>
                              <div style="padding-top: 5px">
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Gross Weight</mat-label>
                                  <input [(ngModel)]="isv.gross_weightFmt"  matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Tare Weight</mat-label>
                                  <input [(ngModel)]="isv.tare_weightFmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Cargo Weight</mat-label>
                                  <input [(ngModel)]="isv.cargo_weightFmt" matInput readonly/>
                                </mat-form-field>
                              </div>

                            </div>
                            <div style="padding-top: 5px">

                            </div>

                          </td>




                          <td style="vertical-align: top; height: 100%;">
                            <div style="background-color: rgba(238,238,237,0.4); border: #E61E00 1px solid; height: 100%">
                              <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Seal Information</div>
                              <div style="padding-top: 5px">
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Seal 1</mat-label>
                                  <input [(ngModel)]="isv.seal_1" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Seal 2</mat-label>
                                  <input [(ngModel)]="isv.seal_2" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Seal 3</mat-label>
                                  <input [(ngModel)]="isv.seal_3" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Seal 4</mat-label>
                                  <input [(ngModel)]="isv.seal_4" matInput readonly/>
                                </mat-form-field>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>


                    </td>
                  </tr>
                </table>
              </mat-card>

              <mat-card class="contDetails">

                <table style="width: 100%">
                  <tr>
                    <td style="width: 26%">
                      <div class="titleFont" style="padding-left: 3%; font-size: 23px">Available:
                        <a *ngIf="isv.available=='Yes'" style="color: green">Yes</a>
                        <a *ngIf="isv.available=='No' && (isv.transit_state_description.toUpperCase()!='DEPARTED' && isv.transit_state.toUpperCase()!='S50_ECOUT' && isv.transit_state.toUpperCase()!='S60_LOADED')" style="color: #E61E00">No</a>
                        <a *ngIf="isv.available=='No' && isv.transit_state_description.toUpperCase()=='DEPARTED' " style="color: #E61E00">Departed</a>
                        <a *ngIf="isv.available=='No' && (isv.transit_state.toUpperCase()=='S50_ECOUT' || isv.transit_state.toUpperCase()=='S60_LOADED') " style="color: darkorange">In Progress</a>
                      </div>
                    </td>
                    <td style="width: 43%">
                      <div class="lowerCaseLetters"   style="font-size: 18px; color: #E61E00; cursor: pointer; ">{{isv.onLienMessage}}</div>
                    </td>
                    <td style="width: 8%">
                      <div class="lowerCaseLetters" [hidden]="txtArray2.length==1" (click)="previousContainer()" style="font-size: 14px; color: #E61E00; cursor: pointer">Prev Container</div>
                    </td>
                    <td style="width: 8%">
                      <div class="lowerCaseLetters" [hidden]="txtArray2.length==1" (click)="nextContainer()" style="font-size: 14px; color: #E61E00; cursor: pointer">Next Container</div>
                    </td>
                  </tr>
                </table>


                <table style="width: 100%; padding: 0px; margin: 0px">
                  <tr>
                    <td style="width: 85%; height: 100%; text-align: center;" >
                      <table  class="table-fill" style="height: 1px">
                        <tr>
                          <td style="vertical-align: top; height: 100%;">
                            <div style="background-color: rgba(238,238,237,0.4); border: #E61E00 1px solid; height: 99.5%">
                              <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Holds & Releases</div>
                              <div>
                                <mat-form-field appearance="outline"  floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Customs Holds</mat-label>
                                  <input [(ngModel)]="isv.customs_releasedFmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline"  floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Freight Released</mat-label>
                                  <input [(ngModel)]="isv.freight_releasedFmt" matInput readonly />
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">USDA Hold</mat-label>
                                  <input [(ngModel)]="isv.usda_releasedFmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div style="padding-top: 5px">
                                <mat-form-field appearance="outline" floatLabel="always" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Other Agency Hold</mat-label>
                                  <input [(ngModel)]="isv.other_agency_releasedFmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div >
                                <mat-form-field appearance="outline" floatLabel="always" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Terminal Hold</mat-label>
                                  <input [(ngModel)]="isv.holdsFmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div >
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Location</mat-label>
                                  <input [(ngModel)]="isv.last_pos_name" matInput readonly/>
                                </mat-form-field>
                              </div>
                            </div>
                          </td>
                          <td style="vertical-align: top; height: 100%;">
                            <div style="background-color: rgba(23,122,241,0.07); border: #E61E00 1px solid; height: 99%">
                              <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 1%;padding-bottom: 15px ">Demurrage & Charges</div>
                              <table style="width: 100%">
                                <tr>
                                    <td style="width: 50%; vertical-align: top">


                                      <div  *ngIf="!isPortAuthority()">
                                        <mat-form-field appearance="outline" >
                                          <mat-label style="font-size: 18px; color: #E61E00">Maher Demurrage Balance Due</mat-label>
                                          <input [(ngModel)]="isv.demurrageBalanceDueMaherFmt" matInput readonly/>
                                        </mat-form-field>
                                      </div>
                                      <div  *ngIf="!isPortAuthority()">
                                        <mat-form-field appearance="outline" floatLabel="always">
                                          <mat-label style="font-size: 18px; color: #E61E00">Line Op Demurrage Balance Due</mat-label>
                                          <input [(ngModel)]="isv.demurrageBalanceDueLineFmt" matInput readonly/>
                                        </mat-form-field>
                                      </div>
                                      <div  *ngIf="!isPortAuthority()">
                                        <mat-form-field appearance="outline" floatLabel="always">
                                          <mat-label style="font-size: 18px; color: #E61E00">Total Demurrage Balance Due</mat-label>
                                          <input [(ngModel)]="isv.demurrageBalanceDueFmt" matInput readonly/>
                                        </mat-form-field>
                                      </div>

                                      <div >
                                        <mat-form-field appearance="outline" *ngIf="!isPortAuthority()" floatLabel="always">
                                          <mat-label style="font-size: 18px; color: #E61E00">Power Balance Due</mat-label>
                                          <input [(ngModel)]="isv.powerBalanceDueFmt" matInput readonly/>
                                        </mat-form-field>
                                      </div>

                                      <div >
                                        <mat-form-field appearance="outline" *ngIf="!isPortAuthority()" floatLabel="always">
                                          <mat-label style="font-size: 18px; color: #E61E00">Exam Charges Due</mat-label>
                                          <input [(ngModel)]="isv.examChargesDueFmt" matInput readonly/>
                                        </mat-form-field>
                                      </div>
                                    </td>
                                    <td style="vertical-align: top">
                                      <div>
                                        <mat-form-field appearance="outline"  floatLabel="always">
                                          <mat-label style="font-size: 18px; color: #E61E00">Discharge Date</mat-label>
                                          <input [(ngModel)]="isv.received_date_fmt" matInput readonly/>
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline"  floatLabel="always">
                                          <mat-label style="font-size: 18px; color: #E61E00">FreeTime Start</mat-label>
                                          <input [(ngModel)]="isv.fte_start_date" matInput readonly/>
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <div>
                                          <mat-form-field appearance="outline"  floatLabel="always">
                                            <mat-label style="font-size: 18px; color: #E61E00">FreeTime End</mat-label>
                                            <input [(ngModel)]="isv.fte_date_fmt" matInput readonly />
                                          </mat-form-field>
                                        </div>
                                        <mat-form-field appearance="outline"  floatLabel="always">
                                          <mat-label style="font-size: 18px; color: #E61E00">Free Days</mat-label>
                                          <input [(ngModel)]="isv.free_days" matInput readonly />
                                        </mat-form-field>
                                      </div>
                                      <div>
                                        <mat-form-field appearance="outline" floatLabel="always">
                                          <mat-label style="font-size: 18px; color: #E61E00">Demurrage Days</mat-label>
                                          <input [(ngModel)]="isv.demurrageDays" matInput readonly/>
                                        </mat-form-field>
                                      </div>

                                    </td>
                                  </tr>
                                <tr >
                                  <td style="text-align: -webkit-left" [colSpan]="whatsTheColSpan(isv)">
                                    <div class="lowerCaseLetters" style="font-size: 12px; text-align: left;"> Maher Statutory Statement</div>
                                    <a style="font-family: almoni; font-weight: bold; font-size: 10px; text-transform: uppercase">

                                      As used herein, the term “Schedule” means Maher’s Terminal Schedule No. 010599, as amended and restated from time to time. The Schedule is publicly available on Maher’s website, <a href="http://www.maherterminals.com" target="_blank">www.maherterminals.com </a>, and is hereby incorporated in this Invoice by reference. The demurrage charges displayed on this Invoice are consistent with the Schedule and the rules of the Federal Maritime Commission related to marine terminal operator demurrage, including the rules contained in 46 CFR 545.5 and 46 CFR Part 541, as such rules may be applicable to Maher. In addition, the performance of Maher’s obligations with respect to the Cargo which forms the subject of this Invoice did not cause or otherwise contribute to the Demurrage charges set forth herein.
                                    </a>
                                  </td>
                                  <td style="text-align: -webkit-left; vertical-align: super" *ngIf="isv.demurrageBalanceDueLineFmt!=null && !isv.demurrageBalanceDueLineFmt.includes('Contact Line Op')" >
                                    <div class="lowerCaseLetters" style="font-size: 12px; text-align: left;"> Line-Op Statutory Statement</div>
                                    <a style="font-family: almoni; font-weight: bold; font-size: 10px; text-transform: uppercase">
                                      AS REQUIRED BY THE OCEAN SHIPPING REFORM ACT OF 2022, PUB. LAW NO. 117-146, THE OCEAN CARRIER ASSOCIATED WITH THE SUBJECT CONTAINER(S) HAS STATED THAT: (1) ITS DEMURRAGE CHARGES AGAINST SUCH CONTAINER(S) ARE CONSISTENT WITH THE RULES OF THE FEDERAL MARITIME COMMISSION WITH RESPECT TO DEMURRAGE, AND (2) ITS PERFORMANCE DID NOT CAUSE OR OTHERWISE CONTRIBUTE TO SUCH DEMURRAGE CHARGES. THE RATES ASSESSED BY THE CARRIER ARE SPECIFIED IN THAT CARRIER’S TARIFF PUBLISHED IN ACCORDANCE WITH THE RULES OF THE FEDERAL MARITIME COMMISSION; PLEASE REFER TO THE CARRIER’S TARIFF FOR FURTHER DETAILS.
                                      </a>
                                  </td>
                                </tr>
                              </table>


                            </div>
                          </td>
                          <td style="vertical-align: top; height: 100%;">
                            <div style="background-color:  rgba(238,238,237,0.4); border: #E61E00 1px solid; height: 99.5%">
                              <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Out Truck Activity</div>

                              <div>
                                <mat-form-field appearance="outline"  floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Delivered Date</mat-label>
                                  <input [(ngModel)]="isv.delivered_date_fmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" floatLabel="always" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Mode Delivered</mat-label>
                                  <input [(ngModel)]="isv.out_mode" matInput readonly />
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" floatLabel="always" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Visit Number</mat-label>
                                  <input [(ngModel)]="isv.out_visit" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div style="padding-top: 5px">
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Reference Number</mat-label>
                                  <input [(ngModel)]="isv.out_transaction_number" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div >
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Trucker</mat-label>
                                  <input [(ngModel)]="isv.out_trucker_description" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div >
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Sealink</mat-label>
                                  <input [(ngModel)]="isv.driver_name" matInput readonly/>
                                </mat-form-field>
                              </div>
                            </div>
                          </td>
                          <td style="vertical-align: top; height: 100%;" [hidden]="allowedToSeeUTCS()">
                            <div style="background-color: rgba(23,122,241,0.07); border: #E61E00 1px solid">
                              <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">UTCS Information</div>

                              <div>
                                <mat-form-field appearance="outline"  floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">SSL</mat-label>
                                  <input [(ngModel)]="isv.line_description" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline"  floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Trucker Status</mat-label>
                                  <input [(ngModel)]="isv.trucker_status" matInput readonly />
                                </mat-form-field>
                              </div>
                              <div >
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Account Status</mat-label>
                                  <input [(ngModel)]="isv.account_status" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Insurance Expiration Date</mat-label>
                                  <input [(ngModel)]="isv.insurance_expiration_date_fmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div style="padding-top: 5px">
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Credit Expiration Date</mat-label>
                                  <input [(ngModel)]="isv.credit_expiration_date_fmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div >
                                <mat-form-field appearance="outline" floatLabel="always">
                                  <mat-label style="font-size: 18px; color: #E61E00">Expiration Date</mat-label>
                                  <input [(ngModel)]="isv.expiration_date_fmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </mat-card>

              <mat-card class="contDetails" >
                <mat-toolbar mat-toolbar class="toolbar4">
                  <mat-toolbar-row style="justify-content: center">
                    <button mat-raised-button [disabled]="isv.requires_power=='0'" (click)="openReefer()"  class="whiteButton"  ><img style="vertical-align: center;height:25px; width: 50px" src="assets/reefer.png" >  Reefer </button>
                    <span style="padding-left: 1%"></span>

                    <button mat-raised-button *ngIf="this.myUser.role=='LINEOP'" [disabled]="isv.hazardsArray.length==0" (click)="openhazards()" class="whiteButton" ><img style="vertical-align: center;height:25px; width: 25px" src="assets/hazards.png" >  Hazards</button>
                    <span style="padding-left: 1%"></span>

                    <button mat-raised-button [disabled]="hArray.length==0" (click)="openHolds()" class="whiteButton" ><img style="vertical-align: center;height:25px; width: 25px" src="assets/customs.png" >  Holds</button>
                    <span style="padding-left: 1%"></span>

                    <button mat-raised-button [disabled]="bolArray.length==0 || isPortAuthority()" (click)="openBills()" class="whiteButton" ><img style="vertical-align: center;height:25px; width: 25px" src="assets/bol.png" >  Bill Of Ladings</button>
                    <span style="padding-left: 1%"></span>

                    <button mat-raised-button [disabled]="isv.bonded_trucker_description==null" (click)="openTruckers()" class="whiteButton" ><img style="vertical-align: center;height:25px; width: 40px" src="assets/local_shipping-24px.svg" >  Bonded Trucker</button>

                  </mat-toolbar-row>
                </mat-toolbar>
                <div>
                  <mat-accordion id="printTable">
                    <mat-expansion-panel [(expanded)]="showAcc"  hideToggle="true">
                      <table style="width: 100%; padding: 0px; margin: 0px" *ngIf="showReeferInfo">
                        <div style="vertical-align: text-top">
                          <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 2%;padding-bottom: 5px ">Reefer Information</div>
                        </div>

                        <tr>
                          <td style="width: 85%; height: 100%; text-align: center;" >
                            <table  class="table-fill">
                              <tr>
                                <td style="vertical-align: top">
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">Container</mat-label>
                                      <input [(ngModel)]="isv.container" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">Genset</mat-label>
                                      <input [(ngModel)]="isv.genset_requirement" matInput readonly />
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">Temp Required</mat-label>
                                      <input [(ngModel)]="isv.temp_reqdFmt" matInput readonly />
                                    </mat-form-field>
                                  </div>

                                </td>
                                <td style="vertical-align: top">
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">FTE Date</mat-label>
                                      <input [(ngModel)]="isv.power_fte_date_fmt" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">Power Days</mat-label>
                                      <input [(ngModel)]="isv.powerDays" matInput readonly />
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">Power Balance Due</mat-label>
                                      <input [(ngModel)]="isv.powerBalanceDueFmt" matInput readonly />
                                    </mat-form-field>
                                  </div>

                                </td>

                              </tr>
                            </table>

                          </td>
                        </tr>
                      </table>

                      <table style="width: 100%; padding: 0px; margin: 0px" *ngIf="showHazInfo">
                        <div style="vertical-align: text-top">

                          <table style="width: 100%">
                            <tr>
                              <td style="width: 80%">
                                <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 2%;padding-bottom: 5px ">Hazardous Information</div>
                              </td>
                              <td style="width: 10%" >
                                <div class="lowerCaseLetters" [hidden]="isv.hazardsArray.length==1"  (click)="previousHazard()"  style="font-size: 14px; color: #E61E00; cursor: pointer">Previous Hazard</div>
                              </td>
                              <td style="width: 10%" >
                                <div class="lowerCaseLetters" [hidden]="isv.hazardsArray.length==1 && myUser.role=='LINEOP'" (click)="nextHazard()" style="font-size: 14px; color: #E61E00; cursor: pointer">Next Hazard</div>
                              </td>
                            </tr>
                          </table>


                        </div>

                        <tr>
                          <td style="width: 85%; height: 100%; text-align: center; " >
                            <table  class="table-fill">
                              <tr>
                                <td style="vertical-align: top">

                                  <div class="flex-item5" style="background-color: rgba(238,238,237,0.4);">

                                    <table style="width: 100%">
                                      <tr>
                                        <td>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">IMDG Class</mat-label>
                                              <input [(ngModel)]="haz.imdgConcat" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline">
                                              <mat-label style="font-size: 18px; color: #E61E00">UNDG</mat-label>
                                              <input [(ngModel)]="haz.undgTypeConcat" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Quantity</mat-label>
                                              <input [(ngModel)]="haz.quantity" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>

                                        <td>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Technical Name</mat-label>
                                              <input [(ngModel)]="haz.tech_name" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Proper Name</mat-label>
                                              <input [(ngModel)]="haz.proper_name" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline">
                                              <mat-label style="font-size: 18px; color: #E61E00">Notes</mat-label>
                                              <input [(ngModel)]="haz.notes" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>


                                        <td>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Package Type</mat-label>
                                              <input [(ngModel)]="haz.package_type" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Package Group</mat-label>
                                              <input [(ngModel)]="haz.package_group" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline">
                                              <mat-label style="font-size: 18px; color: #E61E00">Weight</mat-label>
                                              <input [(ngModel)]="haz.weightDisp" matInput readonly/>
                                            </mat-form-field>
                                          </div>

                                        </td>
                                        <td>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">FlashPoint</mat-label>
                                              <input [(ngModel)]="haz.flashpoint_fmt" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline" >
                                              <mat-label style="font-size: 18px; color: #E61E00">Emergency Phone</mat-label>
                                              <input [(ngModel)]="haz.emergency_telephone_fmt" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                          <div>
                                            <mat-form-field appearance="outline">
                                              <mat-label style="font-size: 18px; color: #E61E00">Marine Pollutants</mat-label>
                                              <input [(ngModel)]="haz.marine_pollutants" matInput readonly/>
                                            </mat-form-field>
                                          </div>
                                        </td>
                                      </tr>

                                    </table>

                                  </div>
                                </td>


                              </tr>
                            </table>

                          </td>
                        </tr>
                      </table>


                      <table style="width: 100%; padding: 0px; margin: 0px" *ngIf="showHoldsInfo" >
                        <div style="vertical-align: text-top">
                          <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 2%;padding-bottom: 5px ">Holds Information</div>
                        </div>

                        <tr>
                          <td style="width: 85%; height: 100%; text-align: center;" >
                            <table  class="table-fill">
                              <tr>
                                <td style="vertical-align: top">

                                  <div class="flex-item4" >
                                    <mat-table  [dataSource]="holdsData" multiTemplateDataRows matSort>
                                      <ng-container matColumnDef="type" >
                                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Type</mat-header-cell>
                                        <mat-cell *matCellDef="let row">{{row.type}}</mat-cell>
                                      </ng-container>
                                      <ng-container matColumnDef="code" >
                                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">ID</mat-header-cell>
                                        <mat-cell *matCellDef="let row">{{row.code}}</mat-cell>
                                      </ng-container>
                                      <ng-container matColumnDef="description" >
                                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Description</mat-header-cell>
                                        <mat-cell *matCellDef="let row">{{row.description}}</mat-cell>
                                      </ng-container>
                                      <mat-header-row *matHeaderRowDef="holdsColumns; sticky: true"></mat-header-row>
                                      <mat-row   *matRowDef="let row; columns: holdsColumns;" class="table-row"></mat-row>
                                    </mat-table>
                                  </div>
                                </td>


                              </tr>
                            </table>

                          </td>
                        </tr>
                      </table>

                      <table style="width: 100%; padding: 0px; margin: 0px" *ngIf="showBillsInfo">
                        <div style="vertical-align: text-top">
                          <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 2%;padding-bottom: 5px ">Bill Of Lading Information</div>

                        </div>

                        <tr>
                          <td style="width: 85%; height: 100%; text-align: center;" >
                            <table  class="table-fill">
                              <tr>
                                <td style="vertical-align: top">

                                  <div class="flex-item4" >
                                    <mat-table  [dataSource]="bolsData" multiTemplateDataRows matSort>
                                      <ng-container matColumnDef="nbr" >
                                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Number</mat-header-cell>
                                        <mat-cell *matCellDef="let row">{{row.nbr}}</mat-cell>
                                      </ng-container>
                                      <ng-container matColumnDef="customs" >
                                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Customs Holds</mat-header-cell>
                                        <mat-cell *matCellDef="let row">{{row.customs}}</mat-cell>
                                      </ng-container>
                                      <ng-container matColumnDef="freight" >
                                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Freight Released</mat-header-cell>
                                        <mat-cell *matCellDef="let row">{{row.freight}}</mat-cell>
                                      </ng-container>
                                      <ng-container matColumnDef="shipper" >
                                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader" >Shipper</mat-header-cell>
                                        <mat-cell *matCellDef="let row">{{row.shipper}}</mat-cell>
                                      </ng-container>
                                      <ng-container matColumnDef="consignee" >
                                        <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Consignee</mat-header-cell>
                                        <mat-cell *matCellDef="let row">{{row.consignee}}</mat-cell>
                                      </ng-container>

                                      <mat-header-row *matHeaderRowDef="getColumnsToLookAtBOL(); sticky: true"></mat-header-row>
                                      <mat-row   *matRowDef="let row; columns: getColumnsToLookAtBOL();" class="table-row"></mat-row>
                                    </mat-table>
                                  </div>
                                </td>


                              </tr>
                            </table>

                          </td>
                        </tr>
                      </table>

                      <table style="width: 100%; padding: 0px; margin: 0px" *ngIf="showTruckerInfo">
                        <div style="vertical-align: text-top">
                          <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 2%;padding-bottom: 5px ">Bonded Trucker Information</div>


                        </div>

                        <tr>
                          <td style="width: 85%; height: 100%; text-align: center;" >
                            <table  class="table-fill">
                              <tr>
                                <td style="vertical-align: top">
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">Trucker</mat-label>
                                      <input [(ngModel)]="isv.bonded_trucker_description" matInput readonly />
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline"  >
                                      <mat-label style="font-size: 18px; color: #E61E00">SCAC Code</mat-label>
                                      <input [(ngModel)]="isv.bonded_trucker_scac" matInput readonly />
                                    </mat-form-field>
                                  </div>

                                </td>


                              </tr>
                            </table>

                          </td>
                        </tr>
                      </table>



                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </mat-card>

            </td>
            <td class="loginPic" style="">

            </td>
          </tr>
        </table>
      </mat-card>


    </td>
    <td class="mainLowerTd">
      <mat-card class="speech-bubble" *ngIf="ipadAppear" id="noPrint">
        <div class="account" style="margin-top: 2%;"></div>
        <div class="titleFont" style="padding-bottom: 10px; ">Import Inquiry </div>



        <div class="flex-item3" style="text-align: center">
          <div  class="lowerCaseLetters" style="font-size: 14px; text-align: center; padding-top: 5px">Enter Up To 100 Containers</div>
          <mat-form-field  appearance="outline" class="newField" >
            <textarea class="textarea" [(ngModel)]="txtFromArea"  matInput cdkTextareaAutosize oninput="this.value = this.value.toUpperCase()"></textarea>
          </mat-form-field>
        </div>
        <div class="errorDiv2" style="text-align: center" *ngIf="didntEnterShit">Must Have 1 Container</div>
        <div class="errorDiv2" style="text-align: center" *ngIf="badContainer">No Container Found or Unauthorized to view</div>
        <div class="errorDiv2" style="text-align: center" *ngIf="badChars">Invalid Character in {{containerNum}}</div>
        <div class="errorDiv2" *ngIf="submitted  && navisError!=null">{{navisError}}</div>

        <div class="errorDiv2" style="text-align: center" *ngIf="submitted && insertNoConts">Must Have At Least 1 Container For Insert</div>

        <mat-toolbar mat-toolbar class="toolbar2" >
          <mat-toolbar-row style="justify-content: center">
            <span style="padding-left: 20px"></span>
            <button mat-raised-button (click)="getSearchItems()"   class="blueButton" >Search</button>
            <span class="example-fill-remaining-space3"></span>

            <button mat-raised-button   class="redButton" (click)="wipeOutSearch()" >Clear List</button>

          </mat-toolbar-row>
        </mat-toolbar>
        <div>
          <mat-form-field class="myOption2"  appearance="outline">
            <mat-label>Saved Lists</mat-label>
            <mat-select  [(value)]="savedList" >
              <mat-option  *ngFor="let lr of savedLists" [value]="lr.id">{{lr.description}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-toolbar class="myToolbar" >
          <mat-toolbar-row style="padding-left: 14%; height: 35px" >
            <button mat-button matTooltip="retrieve your saved list" (click)="showContainersFromList()" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/saved_search-24px.svg" ></button>
            <button mat-button matTooltip="update your saved list" (click)="updateContainerList('U')" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/save-24px.svg" ></button>
            <button mat-button matTooltip="delete your saved list" (click)="deleteHit()" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/delete-24px.svg" ></button>
          </mat-toolbar-row>
        </mat-toolbar>
        <mat-toolbar class="myToolbar" style="background-color: white">
          <mat-toolbar-row >
            <mat-form-field  class="myOption" appearance="outline" >
              <mat-label>New List</mat-label>
              <input maxlength="15" [(ngModel)]="myNewListName"  oninput="this.value = this.value.toUpperCase()" matInput/>
            </mat-form-field>
            <button mat-button matTooltip="create a new saved list" (click)="updateContainerList('I')" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/save-24px.svg" ></button>

          </mat-toolbar-row>
          <mat-toolbar-row style="height: 26px; justify-content: center">
            <div class="errorDiv2" style="text-align: center" *ngIf="submitted2 && insertListExists">List Exists For This User</div>
            <div class="errorDiv2" style="text-align: center" *ngIf="submitted2 && insertNoConts ">List Needs At Least 1 Container</div>
            <div class="errorDiv2" style="text-align: center" *ngIf="submitted2 && noListName ">List Name Cannot Be Blank</div>
          </mat-toolbar-row>
        </mat-toolbar>

      </mat-card>

    </td>
  </tr>
</table>












<!--
<mat-card class="speech-bubble">
  <div class="account" style="margin-top: 2%;"></div>

  <div class="flex-item2">
  <mat-table #table22 [dataSource]="dataSource" multiTemplateDataRows matSort="container" >
    <ng-container matColumnDef="container" >
      <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader"> Find Containers </mat-header-cell>
      <mat-cell *matCellDef="let row">

        <mat-form-field  appearance="outline" (keydown.enter)="newRow(row,$event)"  >
          <mat-icon matPrefix ><img style="vertical-align: center; padding-bottom: 3px; height:20px; width: 20px" src="assets/cargo_container.png" ></mat-icon>

          <input #3   maxlength="11"   [value]="row.stringToFind" [(ngModel)]="row.stringToFind" oninput="this.value = this.value.toUpperCase()" matInput />
        </mat-form-field>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row   *matRowDef="let row; columns: displayedColumns;" style="border-bottom-style: none; height: 10px " ></mat-row>
  </mat-table>
  </div>
  <mat-toolbar mat-toolbar class="toolbar2">
    <mat-toolbar-row>
      <span style="padding-left: 20px"></span>
      <button mat-raised-button   class="blueButton" >Search</button>
      <span class="example-fill-remaining-space3"></span>

      <button mat-raised-button   class="redButton" >Clear List</button>

    </mat-toolbar-row>
  </mat-toolbar>

  <mat-toolbar mat-toolbar class="toolbar2">
    <mat-toolbar-row style="height: 50px">
      <mat-form-field class="myOption2"  appearance="outline">
        <mat-label>Saved Lists</mat-label>
        <mat-select  [(value)]="savedList" >
          <mat-option  *ngFor="let lr of savedLists" [value]="lr.code">{{lr.description}}</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-button  class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/saved_search-24px.svg" ></button>
    </mat-toolbar-row>
    <mat-toolbar-row style="height: 50px; padding-bottom: 10px"  >
      <mat-form-field  class="myOption" appearance="outline" >
        <mat-label>New List</mat-label>
        <input maxlength="30"  oninput="this.value = this.value.toUpperCase()" matInput/>
      </mat-form-field>
      <button mat-button  class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/save-24px.svg" ></button>

    </mat-toolbar-row>
  </mat-toolbar>

</mat-card>

-->

